module.exports = __webpack_public_path__ + "img/hora2.71673dd3.jpg";